import React from "react";
import cityMark from "../Images/city_mark.png";

function ContactUs() {
  return (
    <div className="row">
      <div className="col-md-1">
        <img src={cityMark} alt="mark.png" width="55" height="55" />
      </div>

      <div className="col-md-11">
        If you have any questions, for the fastest service contact us on our
        live chat, in the lower right hand corner Or contact us via email at{" "}
        <a href={"mailto:" + process.env.REACT_APP_DESC_DONORCARE}>
          {" "}
          {process.env.REACT_APP_DESC_DONORCARE}
        </a>
        <br />
        Or call us at{" "}
        <a href={"tel:" + process.env.REACT_APP_DESC_CONTACTUS}>
          {process.env.REACT_APP_DESC_CONTACTUS}
        </a>
        <br />
        Our business hours are Monday - Friday, 8:00am - 7:00pm EST.
      </div>
    </div>
  );
}
export default ContactUs;
